module.exports = __webpack_public_path__ + "img/clock.fa0d4fd0.png";